/** Paths under axios `baseURL` (`/api`). */
export const ApiPath = {
  UsersMe: "/users/me",
  AuthLogout: "/auth/logout",
} as const;
